module.exports = __webpack_public_path__ + "static/media/test3_4.854ae868.png";